import { Pie } from "react-chartjs-2";

const PieChart = ({ revenueData, dataType }) => {
  // 経常収益
  let memberFee = parseInt(revenueData.memberFee.replace(/,/g, ""));
  let donation = parseInt(revenueData.donation.replace(/,/g, ""));
  let businessRevenue = parseInt(revenueData.businessRevenue.replace(/,/g, ""));
  let trusteeRevenue = parseInt(revenueData.trusteeRevenue.replace(/,/g, ""));
  let subsidy = revenueData.subsidy.replace(/,/g, "");
  let bounty = revenueData.bounty.replace(/,/g, "");
  let miscellaneous = parseInt(revenueData.miscellaneous.replace(/,/g, ""));

  // 経常費用
  let expenceProjectPersonnel = parseInt(
    revenueData.expenceProjectPersonnel.replace(/,/g, "")
  );
  let expenceProjectOther = parseInt(
    revenueData.expenceProjectOther.replace(/,/g, "")
  );
  let totalExpensesProject = parseInt(
    revenueData.totalExpensesProject.replace(/,/g, "")
  );
  let expensesAdministrativeHumanOther = parseInt(
    revenueData.expensesAdministrativeHumanOther.replace(/,/g, "")
  );
  let expensesAdministrativeOther = parseInt(
    revenueData.expensesAdministrativeOther.replace(/,/g, "")
  );
  // let totalAdministrativeExpenses = parseInt(revenueData.totalAdministrativeExpenses.replace(/,/g, ""));

  const incomeData = {
    labels: [
      "会費",
      "寄付",
      "自主事業",
      "受託事業",
      "助成金",
      "補助金",
      "その他収益",
    ],

    datasets: [
      {
        data: [
          memberFee,
          donation,
          businessRevenue,
          trusteeRevenue,
          subsidy,
          bounty,
          miscellaneous,
        ],
        backgroundColor: [
          "#e0f9ab",
          "#69d2ceb3",
          "#47a9f3c4",
          "#ffcb2db0",
          "#f49323b5",
          "#ffbbca",
          "#53599ab3",
        ],
        hoverBackgroundColor: [
          "#e0f9ab",
          "#69d2ceb3",
          "#47a9f3c4",
          "#ffcb2db0",
          "#f49323b5",
          "#ffbbca",
          "#53599ab3",
        ],
      },
    ],
  };

  const costData = {
    labels: [
      "事業費・人件費",
      "事業費・その他",
      "管理費・人件費",
      "管理費・その他",
    ],

    datasets: [
      {
        data: [
          expenceProjectPersonnel,
          expenceProjectOther,
          expensesAdministrativeHumanOther,
          expensesAdministrativeOther,
        ],
        backgroundColor: ["#e0f9ab", "#69d2ceb3", "#ffcb2db0", "#f49323b5"],
        hoverBackgroundColor: [
          "#e0f9ab",
          "#69d2ceb3",
          "#ffcb2db0",
          "#f49323b5",
        ],
      },
    ],
  };

  const options = {
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let value = data.datasets[0].data[tooltipItem.index];
          return numberWithCommas(value);
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        },
      },
    },
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <div>
      <Pie
        dataKey="value"
        data={dataType == "経常収益" ? incomeData : costData}
        options={options}
      />
    </div>
  );
};

export default PieChart;
